import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AvailabilityUpdateMainComponent } from './components/availability-update-main/availability-update-main.component';
import { AvailabilityAppErrorNotFoundComponent } from './components/availability-app-errors/availability-app-error-not-found/availability-app-error-not-found.component';
import {
  AvailabilityConfirmationComponent
} from "./components/availability-confirmation/availability-confirmation.component";

const routes: Routes = [
  {
    path: 'availability/confirmation',
    component: AvailabilityConfirmationComponent
  },
  {
    path: 'availability/:userToken',
    component: AvailabilityUpdateMainComponent
  },
  {
    path: 'not-found',
    component: AvailabilityAppErrorNotFoundComponent
  },
  {
    path: '**',
    component: AvailabilityAppErrorNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
